import {formatChartPeriod} from './chart-period';

import type {ChartLabelOptions} from './chart-period';
import type {DailyUserCountByType} from 'src/openapi/admin/models/DailyUserCountByType';

export const SERIES = [
    {key: 'licensed', name: 'Licensed', color: '#35B9C0'},
    {key: 'crm', name: 'CRM', color: '#DD7B2B'},
    {key: 'alert', name: 'Alert', color: '#104E64'},
    {key: 'mobile', name: 'Mobile', color: '#FFB900'},
] as const;

export type HistoryChartData = {
    categories: {category: {label: string}[]}[],
    dataset: {id: string, seriesName: string, color: string, initiallyHidden: string, data: {value: number}[]}[],
};

export const buildChartData = (
    rows: DailyUserCountByType[], hidden: Set<string>, labelOptions: ChartLabelOptions,
): HistoryChartData => ({
    categories: [{category: rows.map(row => ({
        label: formatChartPeriod(row.periodStart, row.periodEnd, labelOptions),
    }))}],
    dataset: SERIES.map(series => ({
        id: series.name,
        seriesName: series.name,
        color: series.color,
        initiallyHidden: hidden.has(series.name) ? '1' : '0',
        data: hidden.has(series.name) ? [] : rows.map(row => ({value: row[series.key]})),
    })),
});
